import { endOfDay, format } from 'date-fns'
import isEmpty from 'lodash-es/isEmpty'
import isEqual from 'lodash-es/isEqual'
import omit from 'lodash-es/omit'

import { DATE_SHORT_FORMAT } from '../../../constants/date'
import { SIZE } from '../../../constants/size'
import { formatDateToApi } from '../../../utils/date'
import { EXCLUDE_FILTERS } from '../Filter.constants'

export function hasFilters(filterValues) {
  if (!filterValues) {
    return false
  }

  const currentFilters = omit(filterValues, EXCLUDE_FILTERS)

  if (isEmpty(currentFilters)) {
    return false
  }

  return true
}

export function isSizeLarge(size) {
  return size === SIZE.LARGE
}

export function getOptionValue(option) {
  return option.id
}

export function getOptionLabel(option) {
  return option.name
}

export function getNextRangeDateOptions({
  asEnd,
  date,
  key,
  options,
  timezone,
}) {
  if (!date) {
    return omit(options, [key])
  }

  const apiDate = asEnd ? endOfDay(date) : date

  return {
    ...options,
    [key]: {
      key,
      label: format(date, DATE_SHORT_FORMAT),
      value: formatDateToApi(apiDate, timezone),
    },
  }
}

export function isEqualApplyFilters({ currentFilters, nextFilters }) {
  return isEqual(nextFilters, currentFilters)
}

export function isEqualEditTemplateFilter({
  isPublic,
  name,
  nextFilterValues,
  prevFilterValues,
  value,
}) {
  return (
    name === value.name &&
    value.is_public === isPublic &&
    isEqual(prevFilterValues, nextFilterValues)
  )
}
